import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { setLogout } from '@modules/auth/lib/authSlice';
import { SessionPayload } from '@modules/bookings/types';

interface BookingState {
    formData: SessionPayload | null;
    shouldBook: boolean;
    redirectPath: string | null;
}

const initialState: BookingState = {
    formData: null,
    shouldBook: false,
    redirectPath: null,
};

const bookingSlice = createSlice({
    name: 'bookingSlice',
    initialState,
    reducers: {
        setBookingData: (state, action: PayloadAction<SessionPayload>) => {
            state.formData = action.payload;
            state.shouldBook = true;
        },
        setRedirectPath: (state, action: PayloadAction<string>) => {
            state.redirectPath = action.payload;
        },
        clearBookingData: state => {
            state.formData = null;
            state.shouldBook = false;
            state.redirectPath = null;
        },
    },
    extraReducers: builder => {
        builder.addCase(setLogout, state => {
            // Clear booking data when user logs out
            bookingSlice.reducer(state, clearBookingData());
        });
    },
});

export const { setBookingData, clearBookingData, setRedirectPath } = bookingSlice.actions;
export default bookingSlice.reducer;
